import { render } from "./DockMenu.vue?vue&type=template&id=621f7eb8"
import script from "./DockMenu.vue?vue&type=script&lang=js"
export * from "./DockMenu.vue?vue&type=script&lang=js"

import "./DockMenu.vue?vue&type=style&index=0&id=621f7eb8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__